import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import OpportunityCard from "../../components/shared/OpportunityCard";
import SectionHeader from "../../components/shared/SectionHeader";
import { Eyebrow } from "../../components/brand";
import { api } from "../../lib/api";
import { useSettings } from "../../lib/settings";

export default function Opportunities() {
  const [params, setParams] = useSearchParams();
  const settings = useSettings();
  const markets = settings?.get("market") || [];
  const propertyTypes = settings?.get("property_type") || [];

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const market = params.get("market") || "";
  const type = params.get("type") || "";

  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams();
    if (market) q.set("market", market);
    if (type) q.set("type", type);
    api.get(`/public/opportunities?${q.toString()}`)
      .then((r) => setList(r.data))
      .finally(() => setLoading(false));
  }, [market, type]);

  const setParam = (k, v) => {
    const next = new URLSearchParams(params);
    if (v) next.set(k, v); else next.delete(k);
    setParams(next);
  };

  return (
    <div data-testid="page-opportunities">
      <section className="bg-altura-ivory py-20">
        <div className="container-editorial">
          <Eyebrow>Opportunities</Eyebrow>
          <SectionHeader title="A curated portfolio of global investment opportunities." subtitle="Restrained. Verified. Explored on your terms." size="lg" className="mt-2" />
        </div>
      </section>

      <section className="bg-altura-beige/30 sticky top-[76px] z-40 border-y border-altura-espresso/10">
        <div className="container-editorial py-4 flex flex-wrap items-center gap-3" data-testid="opportunities-filters">
          <select value={market} onChange={(e) => setParam("market", e.target.value)} className="rounded-full border border-altura-espresso/15 bg-white px-4 py-2 text-sm" data-testid="filter-market">
            <option value="">All Markets</option>
            {markets.map((m) => <option key={m.key} value={m.label}>{m.label}</option>)}
          </select>
          <select value={type} onChange={(e) => setParam("type", e.target.value)} className="rounded-full border border-altura-espresso/15 bg-white px-4 py-2 text-sm" data-testid="filter-type">
            <option value="">All Property Types</option>
            {propertyTypes.map((t) => <option key={t.key} value={t.key}>{t.label}</option>)}
          </select>
          {(market || type) && (
            <button onClick={() => setParams({})} className="text-sm text-altura-espresso link-underline" data-testid="filter-clear">Clear filters</button>
          )}
          <span className="ml-auto text-sm text-altura-charcoal/60">{loading ? "Loading…" : `${list.length} result${list.length === 1 ? "" : "s"}`}</span>
        </div>
      </section>

      <section className="bg-altura-ivory py-16">
        <div className="container-editorial">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {[...Array(6)].map((_, i) => <div key={i} className="h-96 rounded-lg bg-altura-beige/60 animate-pulse" />)}
            </div>
          ) : list.length === 0 ? (
            <div className="text-center py-24">
              <div className="font-editorial text-2xl text-altura-espresso">No opportunities match those filters.</div>
              <Link to="/opportunities" className="btn-outline-gold mt-6">Clear filters</Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {list.map((o) => <OpportunityCard key={o.id} opportunity={o} />)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
